import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { HIT_INDEX_VIEW } from 'redux/actions/business_process';
import { GET_WLA_LIST_TEMPLATE, HIT_WLA_LIST_TEMPLATE } from 'redux/actions/wla';
import { apiListProcessLevel } from 'redux/api/business_process';

function useFetch({
  datas, modal, paramTab, typeModal, levelParent,
}: any) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (datas !== undefined) {
      dispatch({
        type: HIT_WLA_LIST_TEMPLATE,
        payload: {
          process_id: datas.process_id,
        },
      });
    } else {
      dispatch({
        type: GET_WLA_LIST_TEMPLATE,
        payload: [],
      });
    }
  }, []);

  useEffect(() => {
    if (modal) {
      dispatch({
        type: HIT_INDEX_VIEW,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    }
  }, [modal]);

  const getLoadOptions = async (search, loadedOptions, { page = 1 } = {}) => {
    const response = await apiListProcessLevel({
      page,
      page_size: 20,
      board_id: localStorage.getItem('board_id'),
      level: levelParent,
      // search,
    });

    const {
      rows, count, page: currentPage, pagesize,
    } = response;
    const isHasMore = currentPage * pagesize < count;
    const dataMapping = rows.map((item) => ({
      label: item.name,
      value: item.process_id,
    }));

    return {
      options: dataMapping,
      hasMore: isHasMore,
      additional: { page: page + 1 },
    };
  };

  return { getLoadOptions };
}

export default useFetch;
